import React from "react";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Alert from "../../assets/Alert.png";
import dropdownbottom from "../../assets/dropdownbottom.svg";
import BookingEmailConfirmationDialog from "../../components/BookingEmailConfirmationDialog";
import BookingLinkModal from "../../components/BookingLinkModal";
import MarkAsPaidDialog from "../../components/MarkAsPaidDialog";
import { TwPopover } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings, getWebshopUrlForEvent } from "../../utils/confighelpers";
import WarningDialog from "../confirmationModals/WarningDialog";
import { openWhatsapp } from "../../helpers";

export default function ActionPopover({
  bookingDetails,
  handleUpdate,
}) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const { bookingId } = bookingDetails;
  const username = bookingDetails?.student_detail?.username;
  const email = bookingDetails?.student_detail?.email;
  const isPaid = ((["free", "paid", "refund-pendding", "refunded", "classpass"].indexOf(bookingDetails?.paymentStatus?.toLowerCase()) > -1) || (["classpass"].indexOf(bookingDetails?.paymentMethod?.toLowerCase()) > -1)) ? true : false;

  const [bookingEmailConfirmationDialogOpen, setBookingEmailConfirmationDialogOpen] = React.useState(false);
  const [markAsPaidDialogOpen, setMarkAsPaidDialogOpen] = React.useState(false);
  const [openPatmentProfileWarningDialog, setOpenPatmentProfileWarningDialog] = React.useState(false);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);
  const [warningText, setWarningText] = React.useState("");
  const [errorText, setErrorText] = React.useState(false);
  const [bookingLinkModalOpen, setBookingLinkModalOpen] = React.useState(false);
  const [shareLink, setShareLink] = React.useState("false");

  const handleOpenMarkAsPaidDialog = () => {
    setMarkAsPaidDialogOpen(true);
  };
  const handleCloseMarkAsPaidDialog = () => setMarkAsPaidDialogOpen(false);
  const handleOpenWarningDialog = () => {
    setOpenWarningDialog(true);
  };
  const handleCloseWarningDialog = () => setOpenWarningDialog(false);
  const handleOpenErrorDialog = () => {
    addNotificationDialog({
      dialogType: "error",
      dialogTitle: "Error",
      dialogMessage: errorText,
      dialogBtnTitle: "Ok",
      dialogBackdropClick: async () => { },
      dialogBtnClick: async () => { }
    })
  };

  const handleBookingLinkModalOpen = () => setBookingLinkModalOpen(true);
  const handleBookingLinkModalClose = () => setBookingLinkModalOpen(false);

  const sendTikkiePromise = async (type) => {

    const body = {
      bookingId,
      forceSendLink: type,
      bookingFor: "Tikkie",
    };
    const config = {
      method: "post",
      url: `${getUrlForBookings()}payments/generateTikkiePmtLink`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    return request;
  };

  const sendTikkie = async () => {
    const request = await sendTikkiePromise(false);
    if (request.status === 200) {
      console.log(request);
      if (request.data.statusCode === 417) {
        setErrorText(request.data.message.errors ? "Something is wrong please try again" : request.data.message);
        handleOpenErrorDialog();
      } else if (request.data.statusCode === 406) {
        setWarningText(request.data.message.errors ? "Something is wrong please try again" : request.data.message);
        handleOpenWarningDialog();
      } else if (request.data.statusCode === 403) {
        setWarningText(request.data.message.errors ? "Something is wrong please try again" : request.data.message);
        handleCloseWarningDialog();
        setOpenPatmentProfileWarningDialog(true)
      } else if (request.data.statusCode === 200) {
        setShareLink(request.data.data.generatedUrl);
        handleBookingLinkModalOpen();
      }
    }
  };

  const handleMarkAsPaid = async () => {
    handleCloseMarkAsPaidDialog();

    const body = {
      bookingId,
      paymentStatus: "Paid",
      paymentMode: "Cash",
    };
    const config = {
      method: "put",
      url: `${getUrlForBookings()}payments/updatePaymentStatus`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        addSuccessToast("Success!");
        handleUpdate();
        console.log(request);
      } else {
        addErrorToast(request.data.message);
        console.log(request);
      }
    }
  };

  const getStudentInfo = () => {
    let studentDetails = {}

    // if (bookingInfo && bookingInfo?.schedule_class_detail?.participants?.length) {
    //     studentDetails = bookingInfo?.schedule_class_detail?.participants.find((item) => item?.bookingId === bookingInfo.bookingId)
    // }

    if (bookingDetails) {
      studentDetails = bookingDetails?.student_detail
    }

    return studentDetails;
  }

  const getTeacherInfo = () => {
    let teacherDetails = {}

    if (bookingDetails) {
      teacherDetails = bookingDetails?.teacher_detail
    }

    return teacherDetails;
  }

  const generatePurchaseOrder = () => {
    let retObj = {};

    if (bookingDetails && bookingDetails?.ticketsBought?.length) {
      bookingDetails?.ticketsBought.forEach((item, i) => {
        retObj['bookingQty' + (i + 1)] = `${item?.bookingQty} x`;
        retObj['ticketType' + (i + 1)] = item?.ticketType;
        retObj['ticketTotalPrice' + (i + 1)] = `€ ${item?.totalPrice}`;
      })
    }

    if (bookingDetails && bookingDetails?.addonsBought?.length) {
      bookingDetails?.addonsBought.forEach((item, i) => {
        retObj['addonQty' + (i + 1)] = `${item?.bookingQty} x`;
        retObj['addonName' + (i + 1)] = item?.addonName;
        retObj['addonTotalPrice' + (i + 1)] = `€ ${item?.totalPrice}`;
      })
    }

    return retObj
  }

  const calculateServiceFees = () => {
    let serviceFees = 0;

    if (bookingDetails && bookingDetails?.ticketsBought?.length) {
      bookingDetails?.ticketsBought.forEach((item) => {
        // serviceFees = serviceFees + (parseFloat((item?.serviceFee) ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
        serviceFees = serviceFees + (parseFloat((item?.serviceFee) ? item?.serviceFee : 0))
      })
    }

    if (bookingDetails && bookingDetails?.addonsBought?.length) {
      bookingDetails?.addonsBought.forEach((item) => {
        serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
      })
    }

    return parseFloat(serviceFees).toFixed(2)
  }

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    let serviceFees = 0;

    if (bookingDetails?.totalStripeAmount) {
      return parseFloat(bookingDetails?.totalStripeAmount || 0).toFixed(2)
    } else if (bookingDetails?.amount) {
      return parseFloat(bookingDetails?.amount || 0).toFixed(2)
    } else {
      if (bookingDetails && bookingDetails?.ticketsBought?.length) {
        bookingDetails?.ticketsBought.forEach((item) => {
          serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
          totalPrice = totalPrice + parseFloat(item.totalPrice)
        })
      }

      // return parseFloat(totalPrice + serviceFees).toFixed(2)
      return parseFloat(totalPrice).toFixed(2)
    }
  }

  const sendMail = async () => {

    const body = {
      fromName: getTeacherInfo()?.myBusinessProfile?.businessName,
      toName: getStudentInfo().fullName,
      toEmail: getStudentInfo().email,
      bookingType: userReduxState.businessType,
      variables: {
        customer_name: getStudentInfo().fullName,
        ...(userReduxState.businessType === "event" ? {

          eventPhoto: bookingDetails?.event_schedule_detail?.eventPhoto,
          eventName: bookingDetails?.event_schedule_detail?.eventName,
          eventDate: moment(bookingDetails?.event_schedule_detail?.eventDate).format('dddd, MMMM Do'),
          eventTime: moment(bookingDetails?.event_schedule_detail?.eventDate).format('hh:mm A') + " - " + moment(bookingDetails?.event_schedule_detail?.eventEndDate).format('hh:mm A'),
          eventLocation: bookingDetails?.event_schedule_detail?.location?.addressName,
          eventAddress: bookingDetails?.event_schedule_detail?.location?.address,
          mapUrl: `https://www.google.com/maps/dir//${bookingDetails?.event_schedule_detail?.location?.address}`,
        } : {}),
        eventOrganizer: getTeacherInfo()?.myBusinessProfile?.businessName,
        ...(generatePurchaseOrder()),
        // serviceFee: `€ ${calculateServiceFees()}`,
        serviceFee: `€ ${bookingDetails?.totalPaymentServiceFee}`,
        totalPayableAmount: `€ ${calculateTotalPrice()}`,
        paymentMethod: `${bookingDetails?.paymentMethod}`,
        bookingId: `${bookingDetails?.bookingId}`,
        paymentStatus: `${bookingDetails?.paymentStatus}`,
        manageBookingUrl: `${bookingDetails?.manageBookingUrl}`,
        downloadTickets: `${getWebshopUrlForEvent()}get-ticket/${bookingDetails?.manageBookingToken}`,
      }
    };
    const config = {
      method: "post",
      url: `${getUrlForBookings()}sendBookingConfirmation`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setBookingEmailConfirmationDialogOpen(true)
        // addSuccessToast("Success!");
        console.log(request);
      } else {
        addErrorToast(request.data.message);
        console.log(request);
      }
    }
  };

  const handleContactClick = () => {
    if (email) {
      window.open(`mailto:${email}`);
    } else {
      const usernameCopy = username;
      const number = usernameCopy.replace(/[^\w\s]/gi, "").replace(/ /g, "");
      openWhatsapp(number);
    }
  };

  const popoverOptions = [
    // {
    //   text: "Send Tikkie",
    //   onClick: sendTikkie,
    //   disabled: calculateTotalPrice() <= 0 ? true : isPaid,
    //   icon: Alert,
    // },
    {
      text: "Mark as paid",
      onClick: handleOpenMarkAsPaidDialog,
      disabled: calculateTotalPrice() <= 0 ? true : isPaid,
      icon: Alert,
    },
    // {
    //   text: "Contact",
    //   onClick: handleContactClick,
    //   disabled: false,
    //   icon: Alert,
    // },
    {
      text: "Send Email",
      onClick: sendMail,
      disabled: getStudentInfo()?.email ? false : true,
      icon: Alert,
    },
  ];

  return (

    <div className={"w-full"}>
      <TwPopover
        buttonClassName={"bg-blue-bz text-white rounded-lg w-full sm:w-40 p-3"}
        buttonContent={(<span className={"flex flex-row items-center"}>
          <p className={"w-full"}>Actions</p>
          <img src={dropdownbottom} alt={""} />
        </span>)}
      >
        <div className={"flex flex-col divide-y divide-gray-200"}>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              // className={`flex flex-row justify-between items-center gap-4 cursor-pointer px-8 py-2 transition-all ${opt.disabled
              //   ? ""
              //   : "active:bg-light-brown-coffee active:text-white"
              //   } disabled:opacity-60 disabled:cursor-default`}
              className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac disabled:opacity-60 disabled:cursor-default`}
              onClick={opt.onClick}
            >
              <p className={"text-sm"}>{opt.text}</p>
            </button>
          ))}
        </div>
      </TwPopover>

      <BookingEmailConfirmationDialog
        title={`Booking details sent to your ${getStudentInfo()?.email}`}
        // subtitle={`Booking details sent to your ${getStudentInfo().email}`}
        open={bookingEmailConfirmationDialogOpen}
        handleClose={() => setBookingEmailConfirmationDialogOpen(false)}
      />
      <MarkAsPaidDialog
        open={markAsPaidDialogOpen}
        handleClose={handleCloseMarkAsPaidDialog}
        onSubmit={handleMarkAsPaid}
      />
      <WarningDialog
        open={openWarningDialog}
        text={warningText}
        onClose={handleCloseWarningDialog}
        onSubmit={async () => {

          const request = await sendTikkiePromise(true);
          if (request.status === 200) {
            if (request.data.statusCode === 200) {
              setShareLink(request.data.data.generatedUrl);
              handleBookingLinkModalOpen();
              handleCloseWarningDialog();
            } else if (request.data.statusCode === 403) {
              setWarningText(request.data.message.errors ? "Something is wrong please try again" : request.data.message);
              handleCloseWarningDialog();
              setOpenPatmentProfileWarningDialog(true)
            }
          }
        }}
      />

      <WarningDialog
        open={openPatmentProfileWarningDialog}
        text={"You have not enabled your payment settings. Do you want to set it now?"}
        onClose={() => setOpenPatmentProfileWarningDialog(false)}
        onSubmit={async () => {

          navigate("/payment/profile", { replace: true })
        }}
      />
      <BookingLinkModal
        title={"Payment link for " + bookingDetails?.className}
        subtitle="Payment Link Generated"
        open={bookingLinkModalOpen}
        handleClose={handleBookingLinkModalClose}
        bookingLink={shareLink}
      />
    </div>
  );
}
